export default (id) => {
  window.dispatchEvent(new CustomEvent('itemRotate', { detail: { id } }));
};
